export default {
    getUrlParam(name){      //获取地址栏参数值
        var obj = {};
        var url_0=window.location.href;
        var url;
        if(url_0.indexOf('?')!=-1){
            url = url_0.split('?')[1].split('&');
        }else{
            return false
        }  
        var nameList = [];
        url.forEach(function(item) {
            let tempArr = item.split('=');
            let key = decodeURIComponent(tempArr[0]);
            let val = decodeURIComponent(tempArr[1]);
            obj[key] = val;
            nameList.push(key);
        })
        if (nameList.indexOf(name) == -1) {
            return false
        } else {
            return obj[name]
        } 
    },
    unique(arr){    //数组去重方法
        var res=[];
        var obj={};
        for(var i=0;i<arr.length;i++){
            if(!obj[arr[i]]){
                res.push(arr[i]);
                obj[arr[i]] =1
            }
        }
        return res;
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js